import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseCtl, EventService, ServiceLocatorService } from '@ncs/ncs-lib';

@Component({
  selector: 'app-signup-invitation',
  templateUrl: './signup-invitation.component.html',
  styleUrls: ['./signup-invitation.component.css']
})
export class SignupInvitationComponent extends BaseCtl {
  constructor(
    public override locator: ServiceLocatorService,
    private eService: EventService,
    public override route: ActivatedRoute
  ) {
    super(locator.config.get("endpoint.login"), locator, route);
    let _self = this;
    let keySuffix = _self.locator.config.get("CONTEXT_PATH") + "-";
    _self.form.data['loginId']=localStorage.getItem(keySuffix + 'loginId');
    if(_self.form.data['loginId']){
      _self.isreadonly=true;
    }
    localStorage.clear();
    locator.getPathVariable(route, function (params: any) {
      _self.authKey = params["accessKey"];
     // let keySuffix = _self.locator.config.get("CONTEXT_PATH") + "-";
      if (_self.authKey) {
        localStorage.setItem(keySuffix + 'cdAuthkey', _self.authKey);
      } else {
        localStorage.setItem(keySuffix + 'cdAuthkey', "-1");
      }
     // alert(_self.authKey );
    });
  }

  public authKey: string = "";

  override ngOnInit(): void {
    let _self = this;
    _self.form.data['orgId'] = this.locator.config.get("DEFAULT_ORGNIZATION_ID");
  }

  override populateForm(form: any, data: any) {
    form.data.firstName = data.firstName;
    form.data.lastName = data.lastName;
    form.data.loginId = data.loginId;
    form.data.password = data.password;
  }

  isLogin = false;
  isreadonly = false;

  signup() {
    var _self = this;
    let url = this.locator.config.get("endpoint.login") + "/signupInvitation";
    _self.form.data['orgId'] = this.locator.config.get("DEFAULT_ORGNIZATION_ID");
    _self.form.data['roleName'] = this.locator.config.get("DEFAULT_ROLE");
    
    this.locator.http.post(
      url,
      this.form.data,
      function (res: any, error: any) {
        console.log('response', res);
        _self.form.message = '';
        _self.form.inputerror = {};

        if (res.success) {
          _self.isLogin = true;


        } else {
          _self.form.error = !res.success;
          _self.form.message = res.result.message;
          _self.form.inputerror = res.result.inputerror;
        }
      }
    );
  }


  //------show Password---------
  showPassword: boolean = false;

  togglePasswordVisibility(): void {
    this.showPassword = !this.showPassword;
  }

  gotoLogin(){
    let _self=this;
    _self.locator.router.navigateByUrl('/login/' + _self.authKey);
  }
}
